import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Footer from '../../../components/Footer';
import Header from '../../../components/Header';
import { confirmBillingAuth } from './paymentApi';
import './Payment.scss';

type Status = 'loading' | 'success' | 'error';

// Toss successUrl: 정기결제 등록(빌링키 발급) 성공 시 orderId/customerKey/authKey를 쿼리스트링으로
// 넘겨준다 - 기본요금/잔금은 2026-09-18부터 계좌이체 전용으로 전환되어 이 페이지를 거치지 않는다.
const PaymentSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<Status>('loading');
  const [message, setMessage] = useState('');
  const [authChurch, setAuthChurch] = useState<string | null>(null);

  useEffect(() => {
    const orderId = searchParams.get('orderId') || '';
    const authKey = searchParams.get('authKey');
    const customerKey = searchParams.get('customerKey');

    const run = async () => {
      try {
        if (!authKey || !customerKey) {
          throw new Error('결제 정보를 확인할 수 없습니다.');
        }
        const result = await confirmBillingAuth({ orderId, authKey, customerKey });
        setAuthChurch(result.authChurch);
        setStatus('success');
      } catch (error) {
        setStatus('error');
        setMessage(error instanceof Error ? error.message : '결제 확인에 실패했습니다.');
      }
    };

    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="payment-page">
      <Header />
      <section className="payment-section">
        <div className="container">
          <div className="payment-panel">
            {status === 'loading' && <h2 className="payment-panel__title">결제를 확인하고 있습니다...</h2>}
            {status === 'success' && (
              <>
                <h2 className="payment-panel__title">결제가 완료되었습니다</h2>
                {authChurch && (
                  <p className="payment-panel__desc">
                    교회 ID(authChurch): <strong>{authChurch}</strong>가 발급되었습니다. 로그인 계정은 별도로
                    발급되지 않으니, 담당자가 확인 후 관리자 계정 정보를 안내해 드립니다.
                  </p>
                )}
                <Link to="/" className="payment-btn payment-btn--primary">
                  홈으로
                </Link>
              </>
            )}
            {status === 'error' && (
              <>
                <h2 className="payment-panel__title">결제 확인에 실패했습니다</h2>
                <p className="payment-panel__desc">{message}</p>
                <Link to="/payment" className="payment-btn payment-btn--secondary">
                  다시 시도하기
                </Link>
              </>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default PaymentSuccess;
